import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '../src/services/i18n'
import {BrowserRouter} from "react-router-dom";
import {ThemeProvider} from "@mui/material";
import {triumphTheme} from "./theme/triumphTheme";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.Suspense fallback={'loading...'}>
        <BrowserRouter>
            <ThemeProvider theme={triumphTheme}>
                <App/>
            </ThemeProvider>
        </BrowserRouter>
    </React.Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
